module.exports = __webpack_public_path__ + "img/mp4.6eaaf435.svg";